import styled from 'styled-components';

import { body, heading } from '@constants/fonts';

export const TitleDiv = styled.div`
  font-family: ${heading};
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  margin: 5%;
`;

export const DescriptDiv = styled.div`
  font-family: ${body};
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 18px;
  margin: 15px 10% 0 10%;
`;

export const ButtonDiv = styled.div`
  text-align: center;
`;
